import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TelecomService } from '../../../services/telecom/telecom.service'
import { AuthService } from 'src/app/services/auth/auth.service';
import { TimeService } from 'src/app/services/time/time.service';
import { ServiceCatalog } from 'aws-sdk';

const SIZE = 10;
const RETRIES = 3;
const FAIL_LIST_RETRY = 3;

@Component({
  selector: 'app-connect-util',
  templateUrl: './connect-util.component.html',
  styleUrls: ['./connect-util.component.css']
})
export class ConnectUtilComponent implements OnInit {

  //batch upload
  filteredData: Array<any> = [];
  connectUsers: Array<any> = [];
  csvData: Array<string> = [];

  errorCount: number = 0;
  successCount: number = 0;

  selectedFile: File = null;
  fileName: string = "";
  batchDescription: string = "";

  //connect util
  data: Array<any> = [];
  filteredUtilData: Array<any> = [];
  profileList: Array<any> = [];
  profileListReponse: Array<any> = [];
  IdList: Array<any> = [];

  viewSelect = 'default';
  profileSelect = "";
  
  downloadDisabled = true;
  dataView = "general"

  searchString: String = "";
  savedId: string = null;

  retrieving = false;

  //shared
  username: string = "";
  lambdaMessage: string = "";
  lambdaError: boolean = false
  itemsPerPage: number = 20;
  inputItemsPerPage: number = 20;

  showInvaders: boolean = true;

  constructor( private telecomService: TelecomService, private auth: AuthService, private timeService: TimeService) {
  }

  ngOnInit() {
    let identity = this.auth.userPool.getCurrentUser().username;
    if(identity.split("_").length === 2){
      this.username = identity.split('_')[1];
    }else{
      this.username = identity;
    }
    console.log(this.username);
    
    //user config
    this.getIdList();
    //connect utilities
    this.getProfileList();
  }

  setFilteredData(newData: Array<any>){
    this.filteredData = JSON.parse(JSON.stringify(newData));
    console.log(this.filteredData);
  }

  getKeys(obj: any){
    return Object.keys(obj.userData.Tags);
  }

  getValues(obj:any, key:string){
    return obj.userData.Tags[key];
  }

  getSuccessAndErrorCount(){
    this.successCount = 0;
    this.errorCount = 0;
    for(let x=0; x < this.connectUsers.length; x++){
      if(this.connectUsers[x].Status == 'Created'){
        this.successCount++;
      }
      else if(this.connectUsers[x].Status == 'Failed'){
        this.errorCount++;
      }
    }
  }

  enforceMaxNumber(){
    if(this.itemsPerPage == null){
      this.inputItemsPerPage = 1;
    }else{
      if(this.itemsPerPage > 200){
        this.itemsPerPage = 200;
      }else if (this.itemsPerPage < 1){
        this.itemsPerPage = 1
      }
      this.inputItemsPerPage = this.itemsPerPage;
    }
  }

  cleanField(){
    if(this.itemsPerPage == null){
      this.itemsPerPage = 1;
    }
    this.enforceMaxNumber();
  }

  //Connect Utilities------------------------------------------------------------------------------

  getUtility(op: string, id = null): any{
    //reset data
    this.searchString = "";
    this.data = [];
    this.filteredUtilData = [];
    this.downloadDisabled = true;
    this.retrieving = false;
    
    console.log("operation: ", op);
    if(op == "listUsers"){
      return;
    }
    //standard operation
    if(op != "listRoutingProfileQueues" && op != "reportQueues"){
      const params = {
        FunctionName: environment.connectUtilLambdaName,
        Payload: JSON.stringify({'operation': op})
      };
      this.telecomService.callLambda(params, 'An error occurred while trying to perform operation: ' + op).then((response: any) => {
        this.data = response;
        this.downloadDisabled = false;
        this.util_applyFilter();
      });
    //listRoutingProfileQueues requires id field
    }else if( op == "listRoutingProfileQueues" && id != null){
      const params = {
        FunctionName: environment.connectUtilLambdaName,
        Payload: JSON.stringify({
          operation: op,
          params: id
        })
      };
      this.telecomService.callLambda(params, 'An error occurred while trying to perform operation: ' + op).then((response: any) => {
        this.data = response;
        this.downloadDisabled = false;
        this.util_applyFilter();
      });
    }else if(op == "reportQueues"){
      const params = {
        FunctionName: environment.reportGetQueuesLambdaName,
        Payload: JSON.stringify({
          operation: "scan"
        })
      };
      this.telecomService.callLambda(params, 'An error occurred while trying to perform operation: ' + op).then((response: any) => {
        this.data = JSON.parse(response.body);
        console.log(this.data);
        this.downloadDisabled = false;
        this.util_applyFilter();
      });
    }
  }

  getProfileList(){
    let params = {
      FunctionName: environment.connectUtilLambdaName,
      Payload: JSON.stringify({'operation': 'listRoutingProfiles'})
    };
    this.telecomService.callLambda(params, 'An error occurred while trying to retrieve profile list.').then((response: any) => {
      this.profileListReponse = response;
      let temp = response.map(x => x.Name);
      this.profileList = JSON.parse(JSON.stringify(temp));
    });
  }

  setProfileQueue(evt: any){
    this.savedId = this.profileListReponse[evt.index].Id
    this.getUtility(this.viewSelect, this.savedId);
  }


  buildCSV(){
    //create csv
    let csvContent = "data:text/csv;charset=utf-8,";

    if(this.viewSelect != "reportQueues"){
      this.data.forEach(rowObject => {
        let rowArray = Object.values(rowObject);
        csvContent += rowArray.join(',') + "\r\n";
      });
    }else{
      let formatObject = (object)=> {
        return JSON.stringify(object).replace(new RegExp(",", 'g'), ".");
      }
      let replacer = (string, toReplace=",", replaceWith=".") => {
        return string.replace(new RegExp(toReplace, 'g'), replaceWith)
      }
      csvContent += "Name, Date, QueueId, Status, Description, Hours, TimeZone, QuickConnects, OutboundCallerIdName, OutboundPhone, Tags \r\n";
      this.data.forEach(obj => {
        var name = obj["Name"];
        var date = obj["Date"];
        var id = obj["QueueId"];
        var status = obj["Status"];
        var outboundPhone = obj["OutboundPhone"] || "";

        var description = obj["Description"] || "";
        description = replacer(description);

        var hours = obj["HoursOfOperation"] || "";
        hours = (hours == "") ? "" : formatObject(hours);

        // hours of operation description
        var hoursDescription = replacer(obj["HoursOfOperation"]["Description"] || "");

        // hours of operation time zone
        var timeZone = replacer(obj["HoursOfOperation"]["TimeZone"] || "");

        // get type and time of quick connect
        var quickConnect = "";
        if(obj["QuickConnects"]){
          var temp = obj["QuickConnects"].map(x => {
            return {
              type: x["QuickConnectType"],
              name: x["Name"]
            }
          });
          quickConnect = formatObject(temp);
        }

        var outboundName = "";
        if(obj?.OutboundCallerConfig?.OutboundCallerIdName){
          outboundName = obj["OutboundCallerConfig"]["OutboundCallerIdName"];
        }

        var tags = obj["Tags"] || "";
        tags = (tags == "") ? "" : formatObject(tags);
        var newLine = `${name}, ${date}, ${id}, ${status}, ${description}, ${hoursDescription}, ${timeZone}, ${quickConnect}, ${outboundName}, ${outboundPhone}, ${tags}`;
        csvContent += replacer(newLine, '\n', '') + "\r\n";
      });
    }

    console.log("csvContent: ", csvContent);

    //download
    let encodedUri = encodeURI(csvContent);
    let link = document.getElementById("downloadLink");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", this.viewSelect + ".csv");
    link.click();
  }

  util_applyFilter(){
    //1: search
    let temp = [];
    let search = this.searchString.toLowerCase();
    let searchKey = "";
    if(this.viewSelect == 'listRoutingProfileQueues'){
      searchKey = "QueueName";
    }else if(this.viewSelect == 'listUsers'){
      searchKey = "Username";
    }else{
      searchKey = "Name";
    }
    this.data.map(x => {
      if(x && x.hasOwnProperty(searchKey)){
        if(this.viewSelect == "listUsers" && x.hasOwnProperty("Username")){
          if(x["Username"].toLowerCase().includes(search) || 
            x["IdentityInfo"]["FirstName"].toLowerCase().includes(search)|| 
            x["IdentityInfo"]["LastName"].toLowerCase().includes(search)
          ){
            temp.push(x);
          }
        }else if(x[searchKey].toLowerCase().includes(search)){
          temp.push(x);
        }
      }
    });
    console.log("filtered data: ", temp);
    //2: sort
    temp.sort((a, b) => {
      if (a[searchKey] > b[searchKey]) {
          return 1;
      }
      if (a[searchKey] < b[searchKey]) {
          return -1;
      }
      return 0;
    });
    this.filteredUtilData = JSON.parse(JSON.stringify(temp));
  }


  //User List-----------------------------------------------------------
  //part of the Connect Utils Tab

  getIdList(){
    this.lambdaError = false;
    this.lambdaMessage = '';
    let params = {
      FunctionName: environment.connectUtilLambdaName,
      Payload: JSON.stringify({'operation': 'listUsers'})
    };
    this.telecomService.callLambda(params, 'An error occurred while trying to retrieve data: ').then((response: any) => {
      this.IdList = response;
    });
  }

  async getUserList(){
    console.info("userList retreival started")
    this.lambdaError = false;
    this.lambdaMessage = 'Retreiving user data. This may take a few minutes';
    this.data = [];
    this.downloadDisabled = true;
    this.retrieving = true;

    let temp = JSON.parse(JSON.stringify(this.IdList));
    let chunks = [];
    let processFailed: any = false;
    let failList;
    let serviceError;

    // split usersList into batches
    while (temp.length > 0){
      chunks.push(temp.splice(0, SIZE));
    }

    // first pass
    let result = await this.runProcess(chunks);
    console.log("first pass results: ", result);
    failList = result.failList;
    serviceError = result.serviceError;
    if(serviceError){
      this.lambdaError = true;
      this.lambdaMessage = "Encountered an error while retrieving user data. Please try again later."
      this.retrieving = false;
      return;
    }

    // retry failures
    if(failList.length > 0){
      this.lambdaError = true;
      this.lambdaMessage = "Retrying failed users"
      while (failList.length > 0){
        chunks.push(failList.splice(0, SIZE));
      }
      result = await this.runProcess(chunks);
      failList = result.failList;
    }

    //missing users warning
    if(failList.length > 0){
      this.lambdaError = true;
      this.lambdaMessage = `Failed to retrieved data for ${failList.length} users.`
    }
    this.retrieving = false;
    this.downloadDisabled = false;
  }

  async runProcess(chunks){
    let localFailList = [];
    let consecutiveFail = 0
    let serviceError = false;

    while(chunks.length > 0){
      let params = {
        FunctionName: environment.DescribeUserListLambdaName,
        Payload: JSON.stringify({'userList': chunks[0]})
      };
      console.log("outbound request...")
      let result = await this.telecomService.callLambda(params, 'An error occurred while trying to retrieve data: ');
      console.log("response: ", result)
      //invalid response
      if(!(result.successList && result.failList)){
        console.error("invalid lambda response");
        consecutiveFail++;
        if(consecutiveFail == 3){
          serviceError = true;
          break;
        }
        localFailList.concat(chunks[0])
        chunks.splice(0, 1);
      }else{
        consecutiveFail = 0;
        let failList = result["failList"];
        let successList = result["successList"];
        localFailList = localFailList.concat(failList);
        this.data = this.data.concat(successList);
        this.util_applyFilter();
        chunks.splice(0, 1);
      }
    }
    return {
      "failList": localFailList,
      "serviceError": serviceError
    }
  }

  buildUserCSV(){
    //create csv
    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += "First,Last,Username,Id,DID,RoutingProfileId,SecurityProfileIds,Arn,PhoneConfig,Tags\r\n";
    this.data.forEach(rowObject => {
      let first = rowObject["IdentityInfo"]["FirstName"];
      let last = rowObject["IdentityInfo"]["LastName"];
      let username = rowObject["Username"];
      let id = rowObject["Id"];
      let did = rowObject["DirectoryUserId"];
      let routingProfileId = rowObject["RoutingProfileId"];
      let securityProfileIds = rowObject["SecurityProfileIds"].join(" | ");
      let arn = rowObject["Arn"];
      let phoneConfig = this.buildObjectString(rowObject["PhoneConfig"]);
      let tags = this.buildObjectString(rowObject["Tags"]);
      let row = [first, last, username, id, did, routingProfileId, securityProfileIds, arn, phoneConfig, tags];
      csvContent += row.join(',') + "\r\n";
    });
    console.log("csvContent: ", csvContent);
    //download
    let encodedUri = encodeURI(csvContent);
    let link = document.getElementById("downloadLink");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", this.viewSelect + ".csv");
    link.click();
  }

  buildObjectString(obj){
    let keys = Object.keys(obj);
    let outputList = []
    for(let x=0; x < keys.length; x++){
      outputList.push(keys[x] + ":" + obj[keys[x]]);
    }
    return outputList.join(" | ");
  }

  getFirstName(item){
    return item.IdentityInfo.FirstName;
  }

  getLastName(item){
    return item.IdentityInfo.LastName;
  }

  closeInvaders(){
    this.showInvaders = false;
  }

}